// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { RiskRatingChip } from './RiskRatingChip';
import type { PortfolioRiskResult } from './portfolioRisk';

export interface PortfolioRiskBadgeProps {
  result: PortfolioRiskResult;
}

/**
 * Renders an indicative allocation-weighted portfolio risk as a chip on the
 * rounded 1-7 value, with a "partial" marker + tooltip when only some component
 * funds are rated. Em-dash when nothing is rated.
 */
export function PortfolioRiskBadge({ result }: PortfolioRiskBadgeProps) {
  if (result.value == null) {
    return <span className="text-grey-03" aria-label="No portfolio risk">—</span>;
  }
  const title =
    `Weighted portfolio risk ≈ ${result.value.toFixed(1)} of 7` +
    (result.partial ? ` (${result.ratedCount}/${result.total} funds rated)` : '');
  return (
    <span className="flex items-center gap-xs" title={title} data-testid="portfolio-risk-badge">
      <RiskRatingChip rating={result.rounded} />
      {result.partial && <span className="text-body-04 text-grey-03">partial</span>}
    </span>
  );
}
